export function formatCount(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export function formatRate(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${(Number(value) * 100).toFixed(1)}%`;
}

export function formatMoney(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function metricDisplay(metric, formatter = formatCount) {
  if (!metric || metric.state === 'unmeasured') {
    return { text: '—', note: metric?.reason || 'Not measured', unmeasured: true };
  }
  return { text: formatter(metric.value), note: metric.note || null, unmeasured: false };
}
